// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React, { Component } from 'react';
import isEqual from 'lodash.isequal';

export default class MapEditor extends Component {

    state = {
        fields: []
    }

    componentDidMount = () => this.loadMap(this.props.value ?? {})

    componentWillReceiveProps = (next) => {
        if (!isEqual(next.value, this.props.value))
            this.loadMap(next.value);
    }

    loadMap = (map) => {
        let fields = [];
        for (const key in map)
            fields.push({ key, value: map[key] });
        this.setState({fields});
    }

    saveMap = (fields) => {
        this.setState({ fields });
        let map = {};
        for (const field of fields)
            map[field.key] = field.value;
        this.props.onChange(map);
    }

    addField = () => this.saveMap([ ...this.state.fields, { key: "", value: "" } ]);

    editKey = (idx, key) => {
        let fields = [ ...this.state.fields ];
        fields[idx].key = key;
        this.saveMap(fields);
    }

    editValue = (idx, value) => {
        let fields = [ ...this.state.fields ];
        fields[idx].value = value;
        this.saveMap(fields);
    }

    deleteField = (idx) => {
        const fields = [ ...this.state.fields ];
        fields.splice(idx, 1);
        this.saveMap(fields);
    }

    render = () => {
        return (<div className="config-map">
            {Object.keys(this.props.value ?? {}).map((key,idx) => <div
                key={idx}
                className="config-map-field"
            >
                <div className="config-map-key">
                    <input
                        type="text"
                        className="config-map-input"
                        value={key}
                        onChange={e => this.editKey(idx, e.target.value)}
                    />
                </div>
                <div className="config-map-colon">:</div>
                <div className="config-map-value">
                    <input
                        type="text"
                        className="config-map-input"
                        value={(this.props.value ?? {})[key]}
                        onChange={e => this.editValue(idx, e.target.value)}
                    />
                </div>
                <div style={{ clear: 'both', height: 5 }} />
            </div>)}

            {!Object.keys(this.props.value ?? {}).includes("") && <div
                onClick={this.addField}
                className="config-map-add"
            >Add a new field</div>}

        </div>);
    }

}